import emailjs from "@emailjs/browser";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contact } from "../data";

const initialValues = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

const Contact = () => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);

  const validate = (data) => {
    const newErrors = {};

    if (!data.name.trim()) {
      newErrors.name = "El nombre es obligatorio";
    }

    if (!data.email.trim()) {
      newErrors.email = "El correo es obligatorio";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(data.email)) {
      newErrors.email = "Formato de correo inválido";
    }

    if (!data.subject.trim()) {
      newErrors.subject = "El asunto es obligatorio";
    }

    if (!data.message.trim()) {
      newErrors.message = "El mensaje es obligatorio";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate(values);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      toast.warn("Revisa los campos del formulario");
      return;
    }

    try {
      setIsSending(true);
      await emailjs.send(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        {
          from_name: values.name,
          from_email: values.email,
          subject: values.subject,
          message: values.message,
        },
        process.env.REACT_APP_EMAIL_PUBLIC_KEY,
      );

      toast.success("Mensaje enviado correctamente");
      setValues(initialValues);
      setErrors({});
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
      toast.error("Ocurrió un error al enviar el mensaje");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="section bg-primary" id="contacto">
      <div className="container mx-auto">
        <div className="flex flex-col items-center text-center">
          <h2 className="section-title">Contacto</h2>
          <p className="subtitle">
            Si quieres hablar sobre un proyecto o colaboración, envíame un
            mensaje.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 mt-12">
          <div className="flex flex-1 flex-col space-y-8">
            {contact.map(({ icon, title, subtitle, description }, index) => (
              <div className="flex gap-4" key={index}>
                <div className="text-accent text-2xl">{icon}</div>
                <div>
                  <h4 className="text-xl mb-1">{title}</h4>
                  <p className="text-paragraph">{subtitle}</p>
                  <p className="text-accent">{description}</p>
                </div>
              </div>
            ))}
          </div>

          <form
            onSubmit={handleSubmit}
            className="flex-1 space-y-6 max-w-[780px]"
            noValidate
          >
            <div>
              <input
                name="name"
                value={values.name}
                className="input w-full"
                type="text"
                placeholder="Tu nombre"
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>
              )}
            </div>

            <div>
              <input
                name="email"
                value={values.email}
                className="input w-full"
                type="email"
                placeholder="Tu correo"
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">{errors.email}</p>
              )}
            </div>

            <div>
              <input
                name="subject"
                value={values.subject}
                className="input w-full"
                type="text"
                placeholder="Asunto"
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.subject && (
                <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
              )}
            </div>

            <div>
              <textarea
                name="message"
                value={values.message}
                className="textarea w-full"
                placeholder="Tu mensaje"
                onChange={handleChange}
              />
              {errors.message && (
                <p className="text-red-500 text-sm mt-1">{errors.message}</p>
              )}
            </div>

            <button
              type="submit"
              disabled={isSending}
              className="btn btn-lg bg-accent hover:bg-secondary-hover w-full"
            >
              {isSending ? "Enviando..." : "Enviar mensaje"}
            </button>
          </form>
        </div>
      </div>

      <ToastContainer position="top-center" autoClose={2000} />
    </section>
  );
};

export default Contact;
